import React from "react";
import styled from "styled-components";
import colors from "../config/colors";

import Link from "gatsby-link";
import ContentSection from "../components/ContentSection";
import Row from "../components/Row";
import Col from "../components/Col";
import Paragraph from "./Paragraph";

const StyledLink = styled(Link)`
  color: ${colors.gray};
`;

// TODO use fragments instead of spans in headlines when gatsby has react 16
export default () => (
  <ContentSection color={colors.text} id="legal">
    <Row>
      <Col>
        <Paragraph small color="gray">
          Verantwortlich für den Inhalt dieser Seiten:<br />
          Thomas Raithel<br />
          Römerstraße 117<br />
          65205 Wiesbaden<br />
          USt-IdNr. DE281797351<br />
          <br />
          phone: +49 160 8855112<br />
          mail: hello@tomraithel.de<br />
          <br />
          <StyledLink to="/datenschutz">Datenschutzerklärung</StyledLink>
        </Paragraph>
      </Col>
      <Col>
        <Paragraph small color="gray">
          Icons auf dieser Seite: Created by Atif Arshad from the Noun Project
        </Paragraph>
      </Col>
    </Row>
  </ContentSection>
);



// WEBPACK FOOTER //
// ./src/components/Legal.js